import { useState, useEffect, React, useRef } from "react";
import { Link, useLocation} from "react-router-dom";

import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

import * as C from './styles.js'

//swiper slide
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

import Cast from "./componentes/cast";
import Episodes from "./componentes/episodes";
import Crew from "./componentes/crew/index.js";
import Load from "../../../../../../../components/load/index.js";
import { FaArrowLeft, FaXmark } from "react-icons/fa6";

export default function Season( { linkBase, movie_data, movie_type, movie_id, movie_id_imdb } ) {

    const container = useRef();

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const season_number = queryParams.get('temporada');
    
    const [ background, setBackground ] = useState();
    const [ qualidadeImg, setQualidadeImg ] = useState();

    const [ idioma, setIdioma ] = useState();
    const [ economia, setEconomia ] = useState(false);
    const [ loading, setLoading ] = useState(true);
    const [ season, setSeason ] = useState();

    useEffect(()=>{
        
        setLoading(true);
      
        fetch(`https://api.themoviedb.org/3/tv/${movie_id}/season/${season_number}?api_key=${process.env.REACT_APP_TMDB_KEY}&language=pt-BR`)
            .then(Response => Response.json())
            .then(data => {

            setSeason(data);
            console.log('temporada: ', data)
            if (data?.episodes) {
                setBackground(data?.episodes[0]?.still_path)
            }
            setTimeout(() => {
                setLoading(false);
            }, 1000);
            
        });

    }, [ movie_id, season_number ])
    
    const mesesEN = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const mesesPT = ['Jan', 'Fev', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

    function dataConvert(data) {
        // Converte a string de data para um objeto Date
        const dataObj = new Date(data);
      
        // Obtém o mês do objeto Date
        const mes = dataObj.getMonth();
        const language = localStorage.getItem('idioma')

        if (language == "ingles") {
            return ` ${mesesEN[mes]} ${dataObj.getDate() + 1}, ${dataObj.getFullYear()}`;
        } else {
            return `${dataObj.getDate() + 1} de ${mesesPT[mes]} de ${dataObj.getFullYear()}`;
        }
    }

    return(
      <C.Container ref={container} id="container" background={background}>
        {loading && <Load align_center={true}/>}
        {(season_number && !loading) &&
            <div className="content-movie-assistir">
                <header className="header-bts-back">
                    <Link to={`${linkBase}?detalhes=temporadas`}><FaArrowLeft size={20} color='#fff'/></Link>
                    <Link to={`${linkBase}`}><FaXmark size={20} color='#fff'/></Link>
                </header>
                <div className="movie-assistir">
                    <div className="detalhes-movie-assistir">
                    <div className="div-img-background-mobile">
                        <img src={background ? `https://image.tmdb.org/t/p/w780${background}` : "https://www.themoviedb.org/assets/2/v4/glyphicons/basic/glyphicons-basic-38-picture-grey-c2ebdbb057f2a7614185931650f8cee23fa137b93812ccb132b9df511df1cfac.svg"} alt="background image"/>
                        <div className='header-details-movie'>
                        <span className="span-assistir-filmes-series">{idioma == 'ingles' ? `Season ${season?.season_number}` : `Temporada ${season?.season_number}`}</span>
                        <div className="div-title">
                            <h1 className="titulo-movie-assistir"><span>{movie_data?.name}</span></h1>
                        </div>
                        <h5 className="h5-titulo-movie">{season?.name}</h5>
                        </div>
                    </div>
                    <div className="div-padding-detalhes-movie-mobile">
                        <div className="informacoes-movie-assistir">
                        <Swiper
                            slidesPerView={'auto'}
                            spaceBetween={10}
                            freeMode={false}
                            pagination={{
                                clickable: true,
                            }}
                        >
                            {season?.air_date &&
                                <SwiperSlide>
                                    <Tippy content={dataConvert(season && (season?.air_date))}>
                                        <section>
                                            {season?.air_date &&
                                                <span>{season?.air_date.slice(0,4)}</span>
                                            }
                                        </section>
                                    </Tippy>
                                </SwiperSlide>
                            }
                            {season?.vote_average > 0 &&
                                <SwiperSlide>
                                    <Tippy content={idioma == 'ingles' ? 'Rating' : 'Avaliações'}>
                                        <section>
                                            <span><i className="fas fa-star"></i> {season?.vote_average && (season?.vote_average).toFixed(1)}<small>/10</small></span>
                                        </section>
                                    </Tippy>
                                </SwiperSlide>
                            }
                            {(movie_type == 'tv' && season?.episodes?.length) &&
                                <SwiperSlide>
                                    <Tippy content={idioma == 'ingles' ? `${season?.episodes?.length} Episodes` : `${season?.episodes?.length} Episódios`}>
                                        <section className="section-temporadas">
                                            <span>{season?.episodes?.length} Episódios</span>
                                        </section>
                                    </Tippy>
                                </SwiperSlide>
                            }
                        </Swiper>
                    </div>
                    <p className="descricao-movie-assistir">{season?.overview != '' ? season?.overview : movie_data?.overview}</p>
                    <div className="generos-movie-assistir">
                        <Swiper
                            slidesPerView={'auto'}
                            spaceBetween={10}
                            freeMode={false}
                            pagination={{
                            clickable: true,
                            }}
                        >
                            {movie_data?.genres &&
                                movie_data?.genres.map((genero, key) => {
                                    return(
                                        <SwiperSlide key={key}>
                                            <Tippy content={idioma == 'portugues' ? `Ver séries de ${genero.name}` : `View tv series of ${genero.name}`}>
                                                <Link to={`/${movie_type}/genero=${genero.id}/${genero.name}&infantil=false&pagina=1`}>{genero.name}</Link>
                                            </Tippy>
                                        </SwiperSlide>
                                    )
                                })
                            }
                        </Swiper>
                    </div>
                </div>  
                </div>
            </div>
            <Cast id={movie_id} season={season_number}/>
            <Episodes user={movie_data?.user} movie={movie_data} episodes={season?.episodes} season={season_number} setSeason={setSeason} imdb_id={movie_id_imdb}/>
            <Crew id={movie_id} season={season_number}/>
            </div>
        }
      </C.Container>
    )
}